export const IBERDROLA_VARS = Object.freeze({
  PATHS: {
    CSS_TO_POP_UP:
      'https://t.womtp.com/slider/c/Iberdrola/pt/main/create-satellite/modals/fundo-ambiental.css'
  },
  ID_TAG:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a93e99c8370bea01bdf71d694d56ec4d64bba05f118f7c84996a57b4073cfbe20e7c44a0e85bb7bfeb456216a1293476b85fbed83949969f840641c3ab99d7769a9e90c5ac9fa5262b6ce52740fd568ed'
})

export const DOM_ELEMENTS = {
  ADVANTAGES_MUDULE_ID:
    'p_p_id_com_liferay_journal_content_web_portlet_JournalContentPortlet_INSTANCE_Lo5GauGKU5aG_'
}

export const FEEDBACK_MESSAGES = Object.freeze({
  ERROR: {
    NAME_REQUIRED: 'o nome é obrigatório',
    NAME_INVALID: 'o nome não é válido',
    PHONE_REQUIRED: 'o telefone é obrigatório',
    PHONE_INVALID: 'o formato do número não está correto',
    PROMO_CODE_REQUIRED: 'o código é obrigatório',
    PROMO_CODE_INVALID: 'o código é inválido',
    PRIVACY_POLICY: 'aceitar a política de privacidade'
  },
  SUCCESS: {}
})

export const REGEXS = Object.freeze({
  JUST_LETTERS: /^[a-zA-Z\s]+$/,
  PORTUGUESE_NUMBER: /^(\+351|00351|351)?[1-9]\d{8}$/
})

export const FORM_NAMES = Object.freeze({
  PHONE: 'phone',
  POLICY: 'policy',
  PROMO_CODE: 'promo_code'
})

export const ADD_LEAD_ENDPOINT =
  'https://ws.walmeric.com/provision/wsclient/client_addlead.html'

const CONVERSION_TAGS = []

export const DECLARATIVE_TAGS = Object.freeze({
  format: 'jsonp',
  verifyLeadId: 'NO',
  idTag: IBERDROLA_VARS.ID_TAG,
  pop_up: 'yes',
  userAgent: window.navigator.userAgent,
  EConversion: JSON.stringify(CONVERSION_TAGS)
})

export const DECLARATIVE_TAGS_FORM = Object.freeze({
  format: 'jsonp',
  verifyLeadId: 'NO',
  idTag: IBERDROLA_VARS.ID_TAG,
  userAgent: window.navigator.userAgent,
  EConversion: JSON.stringify(CONVERSION_TAGS)
})

export const URL_VISITED = window.location.origin + window.location.pathname

export const URL_TO_POP_UP = [
  // 'https://www.iberdrola.pt/',
  // 'https://www.iberdrola.pt/casa/energia-solar/paineis-solares',
  // 'https://www.iberdrola.pt/casa/energia-solar/baterias'
]

export const URL_TO_WIDGET = [
  'https://www.iberdrola.pt/',
  'https://www.iberdrola.pt/casa/energia/plano-mais-casa-eletricidade',
  'https://www.iberdrola.pt/casa/energia/plano-mais-casa-eletricidade-2',
  'https://www.iberdrola.pt/casa/energia/plano-veiculo-eletrico',
  'https://www.iberdrola.pt/casa/energia/plano-mais-casa-eletricidade-e-gas',
  'https://www.iberdrola.pt/casa/energia/plano-mais-casa-gas',
  'https://www.iberdrola.pt/empresas',
  'https://www.iberdrola.pt/empresas/energia/plano-mais-negocios-eletricidade',
  'https://www.iberdrola.pt/empresas/energia/plano-horeca',
  'https://www.iberdrola.pt/empresas/energia/plano-mais-tri-horario',
  'https://www.iberdrola.pt/empresas/energia/plano-mais-negocios-eletricidade-e-gas',
  'https://www.iberdrola.pt/empresas/energia/plano-mais-negocios-gas',
  'https://www.iberdrola.pt/l/oferta/desconto16',
  'https://www.iberdrola.pt/casa/mobilidade-eletrica/carregar-em-casa',
  // 'https://www.iberdrola.pt/empresas/energia-solar/paineis-solares',
  'https://www.iberdrola.pt/casa/energia-solar/paineis-solares',
  'https://www.iberdrola.pt/casa/energia-solar/baterias',
  'https://www.iberdrola.pt/l/oferta/paineis-solares',
  'https://www.iberdrola.pt/pt/web/guest/casa/mobilidade-eletrica/carregar-em-casa/wallbox-pulsar-plus',
  'https://www.iberdrola.pt/casa/energia/plano-indexado-simples',
  'https://www.iberdrola.pt/empresas/energia/plano-indexado-simples',
  'https://www.iberdrola.pt/casa/mobilidade-eletrica/carregar-em-casa/wallbox-copper-sb',
  // 'https://www.iberdrola.pt/casa/mobilidade-eletrica/carregar-em-casa/wallbox-pulsar-plus',
  'https://www.iberdrola.pt/casa/energia-solar/compra-e-venda-excedentes-autoconsumo',
  'https://www.iberdrola.pt/empresas/energia-solar/compra-e-venda-excedentes',
  'https://www.iberdrola.pt/l/oferta/loja-do-condominio',
  'https://www.iberdrola.pt/l/oferta/faaz'
]

export const URL_DONT_LOAD_WIDGET = [
  'https://www.iberdrola.pt/casa/mobilidade-eletrica/carregar-em-casa/tomada-reforcada',
  'https://www.iberdrola.pt/casa/mobilidade-eletrica/carregar-em-casa/wallbox-pulsar-pro',
]

export const URL_TO_FORM = ['https://www.iberdrola.pt/l/oferta/maisamigo']
